import { featureCollection } from "@turf/turf";
import { MissionType, SiteType } from "@/types";
import type { FeatureCollection } from "geojson";

function filterSitesByMission(
  sites: SiteType[],
  mission: MissionType,
): SiteType[] {
  return sites.filter((site) => {
    const missions = site.missions.split(",");
    return missions.includes(mission.mission_num2);
  });
}

function filterGeoSitesByMission(
  collection: FeatureCollection,
  mission: MissionType,
): FeatureCollection {
  const filteredData = collection.features.filter((feature) => {
    // Split the 'missions' string into an array and check if it contains the mission ID
    let missions = [];
    if (feature.properties) missions = feature.properties.missions.split(",");
    return missions.includes(mission.mission_num2); // Use .includes() for substring matching
  });
  return featureCollection(filteredData);
}

export { filterSitesByMission, filterGeoSitesByMission };
